import TermsButtons from "./termsButtons"

export default TermsButtons
